export const UPDATE_PROFILE = 'UPDATE_PROFILE'
export const UPDATE_PROFILE_PENDING = 'UPDATE_PROFILE_PENDING'
export const UPDATE_PROFILE_FULFILLED = 'UPDATE_PROFILE_FULFILLED'
export const UPDATE_PROFILE_REJECTED = 'UPDATE_PROFILE_REJECTED'